<template>
  <div class="RegisterBottomBanner-box" :style="{ height: open ? '120px' : '0px' }">
    <div class="RegisterBottomBanner" :class="{ open: open }" v-if="!isLogin">
      <div class="RegisterBanner-box">
        <img src="../../assets/img/RegisterBottomBanner.png" alt="" />
        <img class="bottom-banner-close" src="../../assets/img/RegisterBottomClose.png" alt="" @click="handleClose" />
        <p class="bottom-banner-register" @click="handleRegister"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { DEED_MAP, OID_MAP } from "../../utils/constants/constants.track";
import { OLD_USER_CENTER_URL } from "../../utils/constants/constants";

export default {
  name: "LibLayoutRegisterBottomBanner",
  components: {},
  props: {
    alwaysShow: {
      //是否一致展示（刷新后也会有）
      type: Boolean,
      default: false,
    },
    successGoUrl: {
      //登录后的跳转配置
      type: Object,
      default: () => {
        return {
          type: "open",
          url: OLD_USER_CENTER_URL,
        };
      },
    },
    oidType: {
      //埋点记录来源页
      type: String,
      default: "",
    },
  },
  data() {
    return {
      OID_MAP,
      open: false,
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters["basic/isLogin"];
    },
  },
  mounted() {
    this.open = this.alwaysShow;
    if (localStorage.getItem("RegisterBottomBanner") !== "collapsed" && !this.alwaysShow) {
      window.addEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    handleClose() {
      this.open = false;
      localStorage.setItem("RegisterBottomBanner", "collapsed");
    },
    handleRegister() {
      this.$track(DEED_MAP.CLICK, OID_MAP.BANNER_LOGIN_CLICK, {
        extendinfo: this.oidType,
      });
      this.$store.commit("basic/updateIsShowDialogLogin", true);
      this.$store.commit("basic/updateLoginSuccessGo", { type: this.successGoUrl.type, url: this.successGoUrl.url });
    },
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 200) {
        this.open = true;
        window.removeEventListener("scroll", this.handleScroll);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/config.scss";
.RegisterBottomBanner-box {
  width: 100%;
}
.RegisterBottomBanner {
  position: fixed;
  bottom: 0;
  right: -100%;
  height: 120px;
  width: 100%;
  transition: all 0.5s;
  z-index: 1111;
  &.open {
    right: 0;
  }
  .RegisterBanner-box {
    width: 1252px;
    margin: 0 auto;
    position: relative;
    .bottom-banner-close {
      position: absolute;
      right: 10px;
      top: 64px;
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
    .bottom-banner-register {
      position: absolute;
      right: 160px;
      top: 65px;
      width: 154px;
      height: 48px;
      cursor: pointer;
    }
  }
  img {
    width: 100%;
    display: block;
  }
}
</style>
